// sessionStorage key: URL to restore after post-login Keycloak redirect
export const POST_LOGIN_REDIRECT_KEY = 'gfe-post-login-redirect';

// sessionStorage key: set when a request triggers a full Keycloak re-auth
// because the session expired, so the app can inform the user (and warn that
// unsaved changes may have been lost) once they are signed back in.
export const SESSION_EXPIRED_KEY = 'gfe-session-expired';
